import React from "react";

import LetterGridPage from "./background/letters";
import MagneticArrows from "./background/magneticArrows";
import GameOfLife from "./background/gameOfLife";
import ForestFireSim from "./background/forestFireSim";
import Strings from "./background/strings";
import TwoDWave from "./background/TwoDwave";
import ThreeBody from "./background/ThreeBody";
import LagrangePoints from "./background/LagrangePoints";

import './background/letters.css';

//Physics stuff :
// Something with quantics mechanics
//    Orbitals atomiques ?
// Something with relativity
// Graph de collisions de particule
// Something with plasma
// Something with radioactive decroissance

const A = () => <LetterGridPage/>;
const B = () => <MagneticArrows/>;
const C = () => <GameOfLife/>;
const D = () => <ForestFireSim/>;
const E = () => <Strings/>;
const F = () => <TwoDWave/>;
const G = () => <ThreeBody preset="figure8"/>;
const H = () => <ThreeBody preset="lagrange"/>;
const I = () => <ThreeBody preset="burrau"/>;
const J = () => <ThreeBody preset="hierarchical"/>;
const K = () => <ThreeBody preset="sunPlanetMoon"/>;
const L = () => <LagrangePoints/>;

export default function BackgroundChanger({id}) {
  const components = [A, B, C, D, E, F, G, H, I, J, K, L];
  //const components = [L];

  //const Selected = components[id%components.length];
  const Selected = components[Math.floor(Math.random() * components.length)];

  return (
    <div className="background">
      <Selected />
    </div>);
}